export default "__VITE_ASSET__CpslHqFO__"